import { motion } from "framer-motion";

const chapters = [
  { n: "01", t: "PREP", d: "We mask, cover and protect every surface. Cracks filled, holes patched, edges taped with obsessive care." },
  { n: "02", t: "PRIME", d: "The right primer for every wall — sealing stains and giving your colour a flawless, uniform base." },
  { n: "03", t: "PAINT", d: "Premium low-VOC paint applied in smooth, even coats by hands that have done this a thousand times." },
  { n: "04", t: "PERFECT", d: "A full walk-through with you. Touch-ups on the spot. We only leave when it's genuinely perfect." },
];

export default function Manifesto() {
  return (
    <section id="process" className="py-24 md:py-32 bg-[#111] text-[#F6F6F2]" data-testid="manifesto">
      <div className="max-w-7xl mx-auto px-6 grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-4">
          <div className="lg:sticky lg:top-28">
            <p className="font-mono2 text-xs tracking-[0.25em] text-[#FF4500] mb-4">02 / THE PROCESS</p>
            <h2 className="font-head font-extrabold tracking-tighter text-5xl md:text-6xl leading-none">
              Four steps to a finish you'll brag about.
            </h2>
            <p className="mt-6 text-[#94A3B8] leading-relaxed max-w-sm">
              No shortcuts, no mess left behind. Every OutDoEm job follows the same disciplined ritual.
            </p>
          </div>
        </div>

        <div className="lg:col-span-8 space-y-4">
          {chapters.map((c, i) => (
            <motion.div
              key={c.n}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.6, delay: i * 0.05 }}
              className="grid grid-cols-[auto_1fr] gap-6 md:gap-10 items-start border-t border-white/10 pt-8"
            >
              <span className="font-mono2 text-4xl md:text-6xl text-[#005CEE]">{c.n}</span>
              <div>
                <h3 className="font-head font-extrabold tracking-tight text-3xl md:text-4xl">{c.t}</h3>
                <p className="mt-3 text-[#94A3B8] leading-relaxed max-w-xl">{c.d}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
